/*
 * Copyright 2022
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Last modified: 2022.8.6 at 15:35
 */

export default () => {
    let topBtn;

    const init = () => {
        topBtn = document.querySelector('.wp-perf__scroll-top');
        if (topBtn) {
            topBtn.onclick = () => window.scrollTo({top: 0, behavior: 'smooth'});
        }
    };

    init();
};
